<template>
  <ColumnEditModal :value="value" :configName="configName" :columnId="columnId" :editMode="editMode" @input="$emit('input', $event)" v-bind="$attrs">
    <template v-slot:edit-modal-additions="props">
      <v-flex pa-2>
        <v-layout data-ui-component="analyte-name-sandbox" class="grey lighten-2" wrap>
          <v-card-text class="subheading pb-2" style="font-weight: bold;">Try it yourself</v-card-text>
          <AnalyteNameSandbox />
        </v-layout>
      </v-flex>
      <v-layout pa-4 wrap>
        <h3> Create a new Analyte with the Analyte name shown above during Import </h3>
        <v-radio-group column :value="getShouldCreateNewAnalyteValue(props.columnConfiguration)" @change="callSetColumnMetadata(shouldCreateNewAnalyteKey, !(getShouldCreateNewAnalyteValue(props.columnConfiguration)))">
          <v-radio class="radio-opts" label="Allow Analytes to be created in Envirodata when an Analyte does not exist during an import" :value="true" />
          <v-radio class="radio-opts" label="Do not allow Analytes to be created and mark the import as unsuccessful when an Analyte does not exist during the import" :value="false" />
        </v-radio-group>
        <h3> Delete empty Analytes during rollback </h3>
        <v-radio-group column :value="getShouldDeleteDuringRollbackValue(props.columnConfiguration)" @change="callSetColumnMetadata(shouldDeleteDuringRollbackKey, !(getShouldDeleteDuringRollbackValue(props.columnConfiguration)))">
          <v-radio class="radio-opts" label="Delete Analytes that have no data associated with them during a rollback" :value="true" />
          <v-radio class="radio-opts" label="Do not delete Analytes and mark the rollback as unsuccessful when attempting to delete an Analyte" :value="false" />
        </v-radio-group>
      </v-layout>
    </template>
  </ColumnEditModal>
</template>
<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const eddConfiguration = createNamespacedHelpers('plugin/eddConfiguration')
  import ColumnEditModal from './ColumnEditModal'
  import AnalyteNameSandbox from './editModalComponents/AnalyteNameSandbox'
  import metadataFieldNames from '../../store/metadataFieldNames'

  export default {
    components: {
      AnalyteNameSandbox,
      ColumnEditModal,
    },
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      configName: {
        type: String,
        required: true,
      },
      columnId: {
        type: String,
        required: true,
      },
      editMode: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        shouldCreateNewAnalyteKey: metadataFieldNames.analyte_shouldCreateNew,
        shouldDeleteDuringRollbackKey: metadataFieldNames.analyte_shouldDeleteDuringRollback,
      }
    },
    methods: {
      ...eddConfiguration.mapActions(['setColumnMetadata']),
      callSetColumnMetadata(metadataFieldName, metadataValue) {
        this.setColumnMetadata({
          configName: this.configName,
          columnId: this.columnId,
          metadataKey: metadataFieldName,
          metadataValue: metadataValue,
        })
      },
      getShouldCreateNewAnalyteValue(columnConfiguration) {
        return (columnConfiguration && columnConfiguration.Metadata && columnConfiguration.Metadata[this
          .shouldCreateNewAnalyteKey]) || false
      },
      getShouldDeleteDuringRollbackValue(columnConfiguration) {
        return (columnConfiguration && columnConfiguration.Metadata && columnConfiguration.Metadata[this
          .shouldDeleteDuringRollbackKey]) || false
      },
    },
  }
</script>